
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.247 3.482c.54.338.81.507.902.723a.75.75 0 010 .59c-.092.216-.362.385-.902.723L3.71 7.102c-.6.375-.899.562-1.146.542a.75.75 0 01-.542-.3c-.148-.2-.148-.552-.148-1.26V2.916c0-.707 0-1.06.148-1.259a.75.75 0 01.542-.3c.247-.02.547.167 1.146.541l2.536 1.585z","stroke":"#fff","stroke-linejoin":"round"}})])
          )
        }
      }
    